// import React, { useState, useRef, useCallback, useEffect } from "react";
// import { ImageFileUpload, postRequest } from "../Utility/Utility";
// import "./VoxPlayer.css";

// const STATEMENTS = [
//   "Small Property",
//   "I was a small property ravaged by a storm",
//   "The fine weather has returned",
//   "The forest and river have become calm",
//   "The house is vibrant, and shines in the sun",
//   "The field is returning to its order, health and beauty",
//   "Thank you to myself for doing my healing work",
// ];

// const STATE = {
//   IDLE: "idle",
//   RECORDING: "recording",
//   REVIEW: "review",
//   VERIFYING: "verifying",
//   FAILED: "failed",
//   SUCCESS: "success",
// };

// const formatTime = (s) => {
//   if (!s || isNaN(s)) return "0:00";
//   const mins = Math.floor(s / 60);
//   const secs = Math.floor(s % 60);
//   return `${mins}:${secs.toString().padStart(2, "0")}`;
// };

// function useRecorder() {
//   const mr = useRef(null);
//   const chunks = useRef([]);
//   const stream = useRef(null);
//   const [rec, setRec] = useState(false);
//   const [blob, setBlob] = useState(null);
//   const [url, setUrl] = useState(null);
//   const [err, setErr] = useState(null);

//   const start = useCallback(async () => {
//     try {
//       setErr(null);
//       chunks.current = [];
//       const s = await navigator.mediaDevices.getUserMedia({ audio: true });
//       stream.current = s;
//       const m = new MediaRecorder(s);
//       mr.current = m;

//       m.ondataavailable = (e) => {
//         if (e.data.size > 0) {
//           chunks.current.push(e.data);
//         }
//       };

//       m.onstop = () => {
//         const b = new Blob(chunks.current, { type: "audio/webm" });
//         setBlob(b);
//         setUrl(URL.createObjectURL(b));
//         s.getTracks().forEach((t) => t.stop());
//       };

//       m.start(100);
//       setRec(true);
//     } catch (e) {
//       setErr(
//         e.name === "NotAllowedError" ? "Microphone access denied" : e.message,
//       );
//     }
//   }, []);

//   const stop = useCallback(() => {
//     if (mr.current && rec) {
//       mr.current.stop();
//       setRec(false);
//     }
//   }, [rec]);

//   const reset = useCallback(() => {
//     if (url) URL.revokeObjectURL(url);
//     setBlob(null);
//     setUrl(null);
//     setErr(null);
//     chunks.current = [];
//   }, [url]);

//   return { rec, blob, url, err, start, stop, reset };
// }

// export default function VoxPlayer() {
//   // Logout handler
//   const handleLogout = () => {
//     localStorage.removeItem("User_biostartechnology");
//     localStorage.removeItem("User_biostar_userdata");
//     window.location.reload();
//   };
//   const [state, setState] = useState(STATE.IDLE);
//   const [stmt, setStmt] = useState(
//     STATEMENTS[Math.floor(Math.random() * STATEMENTS.length)],
//   );
//   const [status, setStatus] = useState(null);
//   const [elapsed, setElapsed] = useState(0);
//   const { rec, blob, url, err, start, stop, reset } = useRecorder();
//   const audioRef = useRef(null);
//   const [playing, setPlaying] = useState(false);
//   const [time, setTime] = useState(0);
//   const [dur, setDur] = useState(0);
//   const animFrameRef = useRef(null);

//   const params = new URLSearchParams(window.location.search);

//   const voicePlayerId = params.get("uid")?.replace(/"/g, "") || "";

//   console.log("VOICE PLAYER ID FROM URL:", voicePlayerId);
//   console.log("FULL URL:", window.location.href);
//   console.log("QUERY STRING:", window.location.search);

//   useEffect(() => {
//     if (rec) {
//       setState(STATE.RECORDING);
//       setStatus(null);
//       setElapsed(0);
//     } else if (blob && state === STATE.RECORDING) {
//       setState(STATE.REVIEW);
//     }
//   }, [rec, blob, state]);

//   useEffect(() => {
//     if (err) {
//       setStatus({ t: "error", m: err });
//       setState(STATE.IDLE);
//     }
//   }, [err]);

//   useEffect(() => {
//     if (state !== STATE.RECORDING) return;
//     const i = setInterval(() => setElapsed((e) => e + 1), 1000);
//     return () => clearInterval(i);
//   }, [state]);

//   // Get duration using AudioContext when blob is ready
//   useEffect(() => {
//     if (!blob) return;

//     const getDuration = async () => {
//       try {
//         const audioContext = new (
//           window.AudioContext || window.webkitAudioContext
//         )();
//         const arrayBuffer = await blob.arrayBuffer();
//         const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);
//         const duration = audioBuffer.duration;
//         console.log("Duration from AudioContext:", duration);
//         setDur(duration);
//         audioContext.close();
//       } catch (error) {
//         console.error("Error getting duration:", error);
//       }
//     };

//     getDuration();
//   }, [blob]);

//   // Update time using requestAnimationFrame for smooth updates
//   useEffect(() => {
//     const updateTime = () => {
//       if (
//         audioRef.current &&
//         !audioRef.current.paused &&
//         !audioRef.current.ended
//       ) {
//         setTime(audioRef.current.currentTime);
//         animFrameRef.current = requestAnimationFrame(updateTime);
//       }
//     };

//     if (playing && audioRef.current) {
//       updateTime();
//     }

//     return () => {
//       if (animFrameRef.current) {
//         cancelAnimationFrame(animFrameRef.current);
//       }
//     };
//   }, [playing]);

//   // Audio element setup
//   useEffect(() => {
//     const a = audioRef.current;
//     if (!a || !url) return;

//     const onPlay = () => {
//       console.log("Audio started playing");
//       setPlaying(true);
//     };

//     const onPause = () => {
//       console.log("Audio paused");
//       setPlaying(false);
//     };

//     const onEnded = () => {
//       console.log("Audio ended");
//       setPlaying(false);
//       setTime(0);
//       if (a) a.currentTime = 0;
//     };

//     a.addEventListener("play", onPlay);
//     a.addEventListener("pause", onPause);
//     a.addEventListener("ended", onEnded);

//     return () => {
//       a.removeEventListener("play", onPlay);
//       a.removeEventListener("pause", onPause);
//       a.removeEventListener("ended", onEnded);
//     };
//   }, [url]);

//   const onRecord = () => (rec ? stop() : start());

//   const onReset = () => {
//     if (audioRef.current) {
//       audioRef.current.pause();
//       audioRef.current.currentTime = 0;
//     }
//     setPlaying(false);
//     setTime(0);
//     setDur(0);
//     reset();
//     setState(STATE.IDLE);
//     setStatus(null);
//   };

//   const toggle = () => {
//     const a = audioRef.current;
//     if (!a || !url) {
//       console.log("No audio element or URL");
//       return;
//     }

//     console.log(
//       "Toggle clicked. Paused:",
//       a.paused,
//       "Ready state:",
//       a.readyState,
//     );

//     if (a.paused) {
//       console.log("Attempting to play...");
//       const playPromise = a.play();

//       if (playPromise !== undefined) {
//         playPromise
//           .then(() => {
//             console.log("Play successful");
//             setPlaying(true);
//           })
//           .catch((e) => {
//             console.error("Playback failed:", e);
//             setPlaying(false);
//             setStatus({ t: "error", m: "Audio playback failed. Try again." });
//           });
//       }
//     } else {
//       console.log("Pausing audio");
//       a.pause();
//       setPlaying(false);
//     }
//   };

//   const handleProgressClick = (e) => {
//     const a = audioRef.current;
//     if (!a || !dur) return;

//     const progressBar = e.currentTarget;
//     const rect = progressBar.getBoundingClientRect();
//     const clickX = e.clientX - rect.left;
//     const percentage = clickX / rect.width;
//     const newTime = percentage * dur;

//     a.currentTime = newTime;
//     setTime(newTime);
//   };

//   const onSubmit = async () => {
//     if (!blob) return;

//     setState(STATE.VERIFYING);
//     setStatus({ t: "loading", m: "Uploading audio..." });

//     try {
//       const file = new File([blob], "recording.webm", { type: "audio/webm" });

//       // Upload audio file first
//       const uploadRes = await ImageFileUpload(
//         "biostarapp/user/file-upload",
//         file,
//         "file",
//       );

//       let fileUrl = "";

//       if (Array.isArray(uploadRes?.data) && uploadRes.data.length > 0) {
//         fileUrl = uploadRes.data[0];
//       } else if (typeof uploadRes?.data === "string") {
//         fileUrl = uploadRes.data;
//       } else {
//         fileUrl = uploadRes?.fileUrl || uploadRes?.url || uploadRes?.path;
//       }

//       if (!fileUrl) {
//         throw new Error("File upload failed");
//       }

//       setStatus({ t: "loading", m: "Submitting recording..." });

//       // ✅ Send BOTH file + voicePlayerId
//       const submitRes = await postRequest(
//         "biostarapp/user/client/upload/voxplayer/file",
//         {
//           file: fileUrl,
//           voicePlayerId: voicePlayerId,
//         },
//       );

//       setState(STATE.SUCCESS);
//       setStatus({ t: "success", m: submitRes?.msg || "Recording submitted!" });

//       setTimeout(() => {
//         onReset();
//         setStmt(STATEMENTS[Math.floor(Math.random() * STATEMENTS.length)]);
//       }, 3000);
//     } catch (err) {
//       setState(STATE.FAILED);
//       setStatus({
//         t: "error",
//         m:
//           err?.response?.data?.msg ||
//           err?.message ||
//           "Submission failed. Try again.",
//       });
//     }
//   };

//   const canRec = state === STATE.IDLE || state === STATE.FAILED;
//   const canSub = state === STATE.REVIEW;
//   const proc = state === STATE.VERIFYING || state === STATE.SUCCESS;

//   return (
//     <div className="vox-container">
//       {/* Logout button top right */}
//       <button
//         className="logout-btn"
//         onClick={handleLogout}
//         style={{
//           position: "absolute",
//           top: "20px",
//           right: "20px",
//           zIndex: 10,
//           padding: "10px 20px",
//           background: "#f8fafc", // light background
//           color: "#475569",
//           border: "1px solid #e2e8f0",
//           borderRadius: "10px",
//           cursor: "pointer",
//           fontWeight: "500",
//           fontSize: "14px",
//           letterSpacing: "0.3px",
//           boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
//           transition: "all 0.3s ease",
//         }}
//         onMouseOver={(e) => {
//           e.target.style.background = "#ef4444"; // red
//           e.target.style.color = "#ffffff"; // white text
//           e.target.style.borderColor = "#ef4444";
//           e.target.style.transform = "translateY(-2px)";
//           e.target.style.boxShadow = "0 8px 20px rgba(239,68,68,0.35)";
//         }}
//         onMouseOut={(e) => {
//           e.target.style.background = "#f8fafc";
//           e.target.style.color = "#475569";
//           e.target.style.borderColor = "#e2e8f0";
//           e.target.style.transform = "translateY(0px)";
//           e.target.style.boxShadow = "0 4px 12px rgba(0,0,0,0.06)";
//         }}
//       >
//         🚪 Logout
//       </button>

//       <div className="vox-card">
//         <div className="vox-content">
//           {/* Header */}
//           <header className="vox-header">
//             <div className="vox-logo">
//               <div className="vox-icon">
//                 <span className="vox-ring"></span>
//                 <span className="vox-ring"></span>
//                 <span className="vox-ring"></span>
//                 <svg
//                   className="vox-mic-icon"
//                   width="24"
//                   height="24"
//                   viewBox="0 0 24 24"
//                   fill="none"
//                   stroke="#ffffff"
//                   strokeWidth="1.5"
//                 >
//                   <path d="M12 2a3 3 0 00-3 3v7a3 3 0 006 0V5a3 3 0 00-3-3z" />
//                   <path d="M19 10v2a7 7 0 01-14 0v-2" />
//                   <path d="M12 19v3" />
//                 </svg>
//               </div>
//               <h1 className="vox-title">Witness Scan</h1>
//               <span className="vox-badge">Pro</span>
//             </div>
//             <p className="vox-subtitle">Next-Gen Voice Capture</p>
//           </header>

//           {/* Statement Card */}
//           <div className="statement-section">
//             <div className="statement-label">
//               <span className="statement-dot"></span>
//               <span className="statement-text-label">Read aloud</span>
//             </div>
//             <div
//               className={`statement-card ${state === STATE.RECORDING ? "recording" : ""}`}
//             >
//               <p>{stmt}</p>
//             </div>
//           </div>

//           {/* Recording Indicator */}
//           {state === STATE.RECORDING && (
//             <div className="recording-indicator">
//               <div className="recording-badge">
//                 <span className="recording-dot"></span>
//                 <span className="recording-label">Recording</span>
//                 <span className="recording-time">{formatTime(elapsed)}</span>
//                 <div className="recording-wave">
//                   <div className="wave-bar"></div>
//                   <div className="wave-bar"></div>
//                   <div className="wave-bar"></div>
//                   <div className="wave-bar"></div>
//                   <div className="wave-bar"></div>
//                 </div>
//               </div>
//             </div>
//           )}

//           {/* Playback */}
//           {url && state !== STATE.RECORDING && state !== STATE.SUCCESS && (
//             <div className="playback-section">
//               <audio ref={audioRef} src={url} preload="metadata" />
//               <div className="playback-controls">
//                 <button onClick={toggle} className="play-button">
//                   {playing ? (
//                     <svg width="18" height="18" viewBox="0 0 24 24" fill="#fff">
//                       <rect x="6" y="4" width="4" height="16" rx="1" />
//                       <rect x="14" y="4" width="4" height="16" rx="1" />
//                     </svg>
//                   ) : (
//                     <svg width="18" height="18" viewBox="0 0 24 24" fill="#fff">
//                       <path d="M8 5v14l11-7z" />
//                     </svg>
//                   )}
//                 </button>
//                 <div className="playback-progress">
//                   <div className="progress-bar" onClick={handleProgressClick}>
//                     <div
//                       className="progress-fill"
//                       style={{ width: `${dur > 0 ? (time / dur) * 100 : 0}%` }}
//                     />
//                   </div>
//                   <div className="progress-time">
//                     <span className="progress-played">{formatTime(time)}</span>
//                     <span className="progress-total">{formatTime(dur)}</span>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           )}

//           {/* Status */}
//           {status && (
//             <div className={`status-message ${status.t}`}>
//               {status.t === "loading" && <div className="status-spinner" />}
//               {status.t === "success" && (
//                 <svg
//                   width="20"
//                   height="20"
//                   viewBox="0 0 24 24"
//                   fill="none"
//                   stroke="#34d399"
//                   strokeWidth="2"
//                 >
//                   <path d="M22 11.08V12a10 10 0 11-5.93-9.14" />
//                   <path d="M22 4L12 14.01l-3-3" />
//                 </svg>
//               )}
//               {status.t === "error" && (
//                 <svg
//                   width="20"
//                   height="20"
//                   viewBox="0 0 24 24"
//                   fill="none"
//                   stroke="#f43f5e"
//                   strokeWidth="2"
//                 >
//                   <circle cx="12" cy="12" r="10" />
//                   <path d="M15 9l-6 6M9 9l6 6" />
//                 </svg>
//               )}
//               <span className="status-text">{status.m}</span>
//             </div>
//           )}

//           {/* Buttons */}
//           <div className="button-group">
//             {(canRec || state === STATE.RECORDING) && (
//               <button
//                 onClick={onRecord}
//                 disabled={proc}
//                 className={`vox-button ${state === STATE.RECORDING ? "btn-stop" : "btn-record"}`}
//               >
//                 {state === STATE.RECORDING ? (
//                   <>
//                     <svg width="16" height="16" viewBox="0 0 24 24" fill="#fff">
//                       <rect x="6" y="6" width="12" height="12" rx="2" />
//                     </svg>
//                     Stop Recording
//                   </>
//                 ) : (
//                   <>
//                     <svg width="16" height="16" viewBox="0 0 24 24" fill="#fff">
//                       <circle cx="12" cy="12" r="5" />
//                     </svg>
//                     {state === STATE.FAILED ? "Try Again" : "Begin Recording"}
//                   </>
//                 )}
//               </button>
//             )}

//             {canSub && (
//               <button
//                 onClick={onSubmit}
//                 disabled={proc}
//                 className="submit-button"
//               >
//                 <svg
//                   width="16"
//                   height="16"
//                   viewBox="0 0 24 24"
//                   fill="none"
//                   stroke="#fff"
//                   strokeWidth="2"
//                 >
//                   <path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z" />
//                 </svg>
//                 Submit Recording
//               </button>
//             )}

//             {state === STATE.REVIEW && (
//               <button
//                 onClick={onReset}
//                 disabled={proc}
//                 className="vox-button btn-reset"
//               >
//                 <svg
//                   width="14"
//                   height="14"
//                   viewBox="0 0 24 24"
//                   fill="none"
//                   stroke="currentColor"
//                   strokeWidth="2"
//                 >
//                   <path d="M3 12a9 9 0 109-9 9.75 9.75 0 00-6.74 2.74L3 8M3 3v5h5" />
//                 </svg>
//                 Start Over
//               </button>
//             )}
//           </div>

//           {/* Hint */}
//           {state === STATE.IDLE && (
//             <div className="hint-box">
//               <svg
//                 className="hint-icon"
//                 width="18"
//                 height="18"
//                 viewBox="0 0 24 24"
//                 fill="none"
//                 stroke="currentColor"
//                 strokeWidth="1.5"
//               >
//                 <circle cx="12" cy="12" r="10" />
//                 <path d="M12 16v-4M12 8h.01" />
//               </svg>
//               <p className="hint-text">
//                 Read the statement clearly. Your voice will be verified before
//                 submission.
//               </p>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

import React, { useState, useRef, useCallback, useEffect } from "react";
import { ImageFileUpload, postRequest } from "../Utility/Utility";
import "./VoxPlayer.css";

const STATEMENTS = [
  // "Small Property",
  "I was a small property ravaged by a storm",
  "The fine weather has returned",
  "The forest and river have become calm",
  "The house is vibrant, and shines in the sun",
  "The field is returning to its order, health and beauty",
  "Thank you to myself for doing my healing work.",
];

const STATE = {
  IDLE: "idle",
  RECORDING: "recording",
  REVIEW: "review",
  VERIFYING: "verifying",
  FAILED: "failed",
  SUCCESS: "success",
};

const formatTime = (s) => {
  if (!s || isNaN(s)) return "0:00";
  const mins = Math.floor(s / 60);
  const secs = Math.floor(s % 60);
  return `${mins}:${secs.toString().padStart(2, "0")}`;
};

// ─── Modal Component ───────────────────────────────────────────────────────────
function PolicyModal({ type, onClose }) {
  const isTerms = type === "terms";

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-title">
            {isTerms ? "Terms of Service" : "Privacy Policy"}
          </h2>
          <button className="modal-close" onClick={onClose}>
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M18 6L6 18M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div className="modal-body">
          {isTerms ? (
            <div className="modal-content">
              <p>
                <strong>Last Updated: 11 February 2026</strong>
              </p>

              <p>
                These Terms of Service govern your access to and use of{" "}
                <strong>Witness Scan</strong>
                ("we", "our", or "us") website, applications, and voice-based
                services (collectively, the “Services”). By using our Services,
                you agree to these Terms.
              </p>

              <p>
                <strong>1. Eligibility</strong>
              </p>
              <p>
                You must be at least 18 years old to use Witness Scan Services.
                By accessing the platform, you confirm that you meet this
                requirement.
              </p>

              <p>
                <strong>2. Account Responsibility</strong>
              </p>
              <p>
                You are responsible for maintaining the confidentiality of your
                account credentials and all activities that occur under your
                account.
              </p>

              <p>
                <strong>3. Use of Services</strong>
              </p>
              <p>
                You agree to use Witness Scan only for lawful purposes and not
                to misuse, copy, resell, or exploit any part of the Services.
              </p>

              <p>
                <strong>4. Voice & AI Services</strong>
              </p>
              <p>
                Witness Scan provides AI-powered voice services including voice
                modeling, speech synthesis, dubbing, translation, and
                verification. You confirm that you have rights and consent to
                upload any audio content.
              </p>

              <p>
                <strong>5. Payments</strong>
              </p>
              <p>
                Certain features may require payment. All payments are processed
                securely through third-party providers. Fees are non-refundable
                unless required by law.
              </p>

              <p>
                <strong>6. Intellectual Property</strong>
              </p>
              <p>
                All platform content, software, and technology belong to Witness
                Scan. Users retain ownership of uploaded content but grant
                Witness Scan permission to process it for providing Services.
              </p>

              <p>
                <strong>7. Prohibited Activities</strong>
              </p>
              <p>
                • Upload illegal or harmful content
                <br />
                • Attempt to access systems without authorization
                <br />
                • Use Services for fraud or impersonation
                <br />• Interfere with platform security
              </p>

              <p>
                <strong>8. Service Availability</strong>
              </p>
              <p>
                We strive to keep Services available but do not guarantee
                uninterrupted or error-free operation.
              </p>

              <p>
                <strong>9. Termination</strong>
              </p>
              <p>
                We may suspend or terminate access if you violate these Terms or
                misuse the platform.
              </p>

              <p>
                <strong>10. Limitation of Liability</strong>
              </p>
              <p>
                Witness Scan is not liable for indirect, incidental, or
                consequential damages arising from use of the Services.
              </p>

              <p>
                <strong>11. Changes to Terms</strong>
              </p>
              <p>
                We may update these Terms from time to time. Continued use means
                acceptance of revised Terms.
              </p>

              <p>
                <strong>12. Governing Law</strong>
              </p>
              <p>These Terms are governed by applicable local laws.</p>

              <p>
                <strong>Contact Us:</strong>
              </p>
              <p>
                For questions regarding these Terms, please contact:
                <br />
                {/* <strong>legal@witnessscan.com</strong> */}
              </p>
            </div>
          ) : (
            <>
              <div className="modal-content">
                <p>
                  <strong>Last Updated: 11 February 2026</strong>
                </p>

                <p>
                  This Privacy Policy explains how <strong>Witness Scan</strong>{" "}
                  ("we", "our", or "us") collects, uses, processes, and protects
                  your Personal Data when you use our website, applications, and
                  voice-based services (collectively, the “Services”).
                </p>

                <p>
                  <strong>Personal Data</strong> refers to any information that
                  identifies or may identify you, including your name, email
                  address, phone number, IP address, device information, and
                  voice recordings.
                </p>

                <p>
                  <strong>Information We Collect:</strong>
                </p>
                <p>
                  • Account & Contact Details (name, email, phone number)
                  <br />
                  • Voice Data & Audio Recordings uploaded to Witness Scan
                  <br />
                  • Device & Usage Information (IP address, browser, operating
                  system)
                  <br />
                  • Payment Information (processed securely through third-party
                  providers)
                  <br />• Communications, inquiries, and feedback
                </p>

                <p>
                  <strong>Voice & AI Processing:</strong>
                </p>
                <p>
                  Witness Scan uses AI-powered voice technologies to analyze
                  uploaded audio for services including voice modeling, speech
                  synthesis, dubbing, and translation. Voice data may be treated
                  as biometric information under applicable laws.
                </p>

                <p>
                  <strong>How We Use Your Data:</strong>
                </p>
                <p>
                  • To operate and enhance Witness Scan Services
                  <br />
                  • To generate and manage voice models
                  <br />
                  • For security, fraud prevention, and legal compliance
                  <br />
                  • For billing and payment processing
                  <br />• For research and improvement of AI systems
                </p>

                <p>
                  <strong>Legal Basis:</strong>
                </p>
                <p>
                  Personal Data is processed based on contractual necessity,
                  legitimate interests, legal obligations, or user consent where
                  applicable.
                </p>

                <p>
                  <strong>Data Sharing:</strong>
                </p>
                <p>
                  We may share data with trusted partners such as cloud hosting
                  providers, analytics services, and payment processors solely
                  to support Witness Scan operations. We never sell your
                  Personal Data.
                </p>

                <p>
                  <strong>International Transfers:</strong>
                </p>
                <p>
                  Your data may be stored or processed in the United States or
                  other countries where our service providers operate.
                  Appropriate safeguards are applied in accordance with
                  applicable laws.
                </p>

                <p>
                  <strong>Data Retention:</strong>
                </p>
                <p>
                  Personal Data is retained only as long as necessary to provide
                  Services or meet legal requirements. Voice-related data is
                  deleted within three (3) years of your last interaction unless
                  legally required otherwise.
                </p>

                <p>
                  <strong>Your Rights:</strong>
                </p>
                <p>
                  • Access or correction of your data
                  <br />
                  • Deletion or anonymization
                  <br />
                  • Withdrawal of consent
                  <br />
                  • Objection to processing
                  <br />• Data portability
                </p>

                <p>
                  <strong>Cookies:</strong>
                </p>
                <p>
                  Witness Scan uses cookies for core functionality, analytics,
                  and marketing. Cookie preferences can be managed via your
                  browser settings.
                </p>

                <p>
                  <strong>Children’s Privacy:</strong>
                </p>
                <p>
                  Witness Scan Services are not intended for users under 18
                  years of age. We do not knowingly collect children’s Personal
                  Data.
                </p>

                <p>
                  <strong>Security:</strong>
                </p>
                <p>
                  We apply industry-standard security measures to safeguard
                  Personal Data, but no system can guarantee absolute
                  protection.
                </p>

                <p>
                  <strong>Contact Us:</strong>
                </p>
                <p>
                  For privacy inquiries, please contact Witness Scan’s Data
                  Protection Officer:
                  <br />
                  {/* <strong>legal@witnessscan.com</strong> */}
                </p>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

// ─── Recorder Hook ─────────────────────────────────────────────────────────────
function useRecorder() {
  const mr = useRef(null);
  const chunks = useRef([]);
  const stream = useRef(null);
  const [rec, setRec] = useState(false);
  const [blob, setBlob] = useState(null);
  const [url, setUrl] = useState(null);
  const [err, setErr] = useState(null);

  const start = useCallback(async () => {
    try {
      setErr(null);
      chunks.current = [];
      const s = await navigator.mediaDevices.getUserMedia({ audio: true });
      stream.current = s;
      const m = new MediaRecorder(s);
      mr.current = m;

      m.ondataavailable = (e) => {
        if (e.data.size > 0) chunks.current.push(e.data);
      };

      m.onstop = () => {
        const b = new Blob(chunks.current, { type: "audio/webm" });
        setBlob(b);
        setUrl(URL.createObjectURL(b));
        s.getTracks().forEach((t) => t.stop());
      };

      m.start(100);
      setRec(true);
    } catch (e) {
      setErr(
        e.name === "NotAllowedError" ? "Microphone access denied" : e.message,
      );
    }
  }, []);

  const stop = useCallback(() => {
    if (mr.current && rec) {
      mr.current.stop();
      setRec(false);
    }
  }, [rec]);

  const reset = useCallback(() => {
    if (url) URL.revokeObjectURL(url);
    setBlob(null);
    setUrl(null);
    setErr(null);
    chunks.current = [];
  }, [url]);

  return { rec, blob, url, err, start, stop, reset };
}

// ─── Main Component ────────────────────────────────────────────────────────────
export default function VoxPlayer() {
  const handleLogout = () => {
    localStorage.removeItem("User_biostartechnology");
    localStorage.removeItem("User_biostar_userdata");
    window.location.reload();
  };

  const [state, setState] = useState(STATE.IDLE);
  // const [stmt, setStmt] = useState(
  //   STATEMENTS[Math.floor(Math.random() * STATEMENTS.length)],
  // );

  const [stmt] = useState(STATEMENTS);
  const [status, setStatus] = useState(null);
  const [elapsed, setElapsed] = useState(0);
  const { rec, blob, url, err, start, stop, reset } = useRecorder();
  const audioRef = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [time, setTime] = useState(0);
  const [dur, setDur] = useState(0);
  const animFrameRef = useRef(null);

  // ── Consent state ──
  const [consentChecked, setConsentChecked] = useState(false);
  const [modalType, setModalType] = useState(null); // 'terms' | 'privacy' | null

  const params = new URLSearchParams(window.location.search);
  const voicePlayerId = params.get("uid")?.replace(/"/g, "") || "";

  useEffect(() => {
    if (rec) {
      setState(STATE.RECORDING);
      setStatus(null);
      setElapsed(0);
    } else if (blob && state === STATE.RECORDING) {
      setState(STATE.REVIEW);
    }
  }, [rec, blob, state]);

  useEffect(() => {
    if (err) {
      setStatus({ t: "error", m: err });
      setState(STATE.IDLE);
    }
  }, [err]);

  useEffect(() => {
    if (state !== STATE.RECORDING) return;
    const i = setInterval(() => setElapsed((e) => e + 1), 1000);
    return () => clearInterval(i);
  }, [state]);

  useEffect(() => {
    if (!blob) return;
    const getDuration = async () => {
      try {
        const audioContext = new (
          window.AudioContext || window.webkitAudioContext
        )();
        const arrayBuffer = await blob.arrayBuffer();
        const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);
        setDur(audioBuffer.duration);
        audioContext.close();
      } catch (error) {
        console.error("Error getting duration:", error);
      }
    };
    getDuration();
  }, [blob]);

  useEffect(() => {
    const updateTime = () => {
      if (
        audioRef.current &&
        !audioRef.current.paused &&
        !audioRef.current.ended
      ) {
        setTime(audioRef.current.currentTime);
        animFrameRef.current = requestAnimationFrame(updateTime);
      }
    };
    if (playing && audioRef.current) updateTime();
    return () => {
      if (animFrameRef.current) cancelAnimationFrame(animFrameRef.current);
    };
  }, [playing]);

  useEffect(() => {
    const a = audioRef.current;
    if (!a || !url) return;
    const onPlay = () => setPlaying(true);
    const onPause = () => setPlaying(false);
    const onEnded = () => {
      setPlaying(false);
      setTime(0);
      if (a) a.currentTime = 0;
    };
    a.addEventListener("play", onPlay);
    a.addEventListener("pause", onPause);
    a.addEventListener("ended", onEnded);
    return () => {
      a.removeEventListener("play", onPlay);
      a.removeEventListener("pause", onPause);
      a.removeEventListener("ended", onEnded);
    };
  }, [url]);

  const onRecord = () => (rec ? stop() : start());

  const onReset = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
    setPlaying(false);
    setTime(0);
    setDur(0);
    reset();
    setState(STATE.IDLE);
    setStatus(null);
  };

  const toggle = () => {
    const a = audioRef.current;
    if (!a || !url) return;
    if (a.paused) {
      a.play()
        .then(() => setPlaying(true))
        .catch(() => {
          setPlaying(false);
          setStatus({ t: "error", m: "Audio playback failed. Try again." });
        });
    } else {
      a.pause();
      setPlaying(false);
    }
  };

  const handleProgressClick = (e) => {
    const a = audioRef.current;
    if (!a || !dur) return;
    const rect = e.currentTarget.getBoundingClientRect();
    const percentage = (e.clientX - rect.left) / rect.width;
    const newTime = percentage * dur;
    a.currentTime = newTime;
    setTime(newTime);
  };

  const onSubmit = async () => {
    if (!blob) return;
    setState(STATE.VERIFYING);
    setStatus({ t: "loading", m: "Uploading audio..." });
    try {
      const file = new File([blob], "recording.webm", { type: "audio/webm" });
      const uploadRes = await ImageFileUpload(
        "biostarapp/user/file-upload",
        file,
        "file",
      );
      let fileUrl = "";
      if (Array.isArray(uploadRes?.data) && uploadRes.data.length > 0)
        fileUrl = uploadRes.data[0];
      else if (typeof uploadRes?.data === "string") fileUrl = uploadRes.data;
      else fileUrl = uploadRes?.fileUrl || uploadRes?.url || uploadRes?.path;
      if (!fileUrl) throw new Error("File upload failed");
      setStatus({ t: "loading", m: "Submitting recording..." });
      const submitRes = await postRequest(
        "biostarapp/user/client/upload/voxplayer/file",
        {
          file: fileUrl,
          voicePlayerId,
        },
      );
      setState(STATE.SUCCESS);
      setStatus({ t: "success", m: submitRes?.msg || "Recording submitted!" });
      setTimeout(() => {
        onReset();
        // setStmt(STATEMENTS[Math.floor(Math.random() * STATEMENTS.length)]);
      }, 3000);
    } catch (err) {
      setState(STATE.FAILED);
      setStatus({
        t: "error",
        m:
          err?.response?.data?.msg ||
          err?.message ||
          "Submission failed. Try again.",
      });
    }
  };

  const canRec = state === STATE.IDLE || state === STATE.FAILED;
  const canSub = state === STATE.REVIEW;
  const proc = state === STATE.VERIFYING || state === STATE.SUCCESS;

  return (
    <div className="vox-container">
      {/* Logout */}
      <button
        className="logout-btn"
        onClick={handleLogout}
        style={{
          position: "absolute",
          top: "20px",
          right: "20px",
          zIndex: 10,
          padding: "10px 20px",
          background: "#f8fafc",
          color: "#475569",
          border: "1px solid #e2e8f0",
          borderRadius: "10px",
          cursor: "pointer",
          fontWeight: "500",
          fontSize: "14px",
          letterSpacing: "0.3px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
          transition: "all 0.3s ease",
        }}
        onMouseOver={(e) => {
          e.target.style.background = "#ef4444";
          e.target.style.color = "#ffffff";
          e.target.style.borderColor = "#ef4444";
          e.target.style.transform = "translateY(-2px)";
          e.target.style.boxShadow = "0 8px 20px rgba(239,68,68,0.35)";
        }}
        onMouseOut={(e) => {
          e.target.style.background = "#f8fafc";
          e.target.style.color = "#475569";
          e.target.style.borderColor = "#e2e8f0";
          e.target.style.transform = "translateY(0px)";
          e.target.style.boxShadow = "0 4px 12px rgba(0,0,0,0.06)";
        }}
      >
        🚪 Logout
      </button>

      <div className="vox-card">
        <div className="vox-content">
          {/* Header */}
          <header className="vox-header">
            <div className="vox-logo">
              <div className="vox-icon">
                <span className="vox-ring"></span>
                <span className="vox-ring"></span>
                <span className="vox-ring"></span>
                <svg
                  className="vox-mic-icon"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#ffffff"
                  strokeWidth="1.5"
                >
                  <path d="M12 2a3 3 0 00-3 3v7a3 3 0 006 0V5a3 3 0 00-3-3z" />
                  <path d="M19 10v2a7 7 0 01-14 0v-2" />
                  <path d="M12 19v3" />
                </svg>
              </div>
              <h1 className="vox-title">Witness Scan</h1>
              <span className="vox-badge">Pro</span>
            </div>
            <p className="vox-subtitle">Next-Gen Voice Capture</p>

            {/* ── Consent Checkbox ── */}
            <div className="consent-row">
              <label className="consent-label">
                <div className="consent-check-wrapper">
                  <input
                    type="checkbox"
                    className="consent-checkbox"
                    checked={consentChecked}
                    onChange={(e) => setConsentChecked(e.target.checked)}
                  />
                  <span className="consent-checkmark">
                    {consentChecked && (
                      <svg
                        width="11"
                        height="11"
                        viewBox="0 0 12 12"
                        fill="none"
                      >
                        <path
                          d="M2 6l3 3 5-5"
                          stroke="#ffffff"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    )}
                  </span>
                </div>
                <span className="consent-text">
                  You hereby confirm that you have all necessary rights or
                  consents to upload and clone these voice samples. You take
                  full responsibility for the accuracy of the files you upload
                  to and generate on the Platform. You reaffirm your obligation
                  to abide by Witness Scan{" "}
                  <button
                    type="button"
                    className="consent-link"
                    onClick={(e) => {
                      e.preventDefault();
                      setModalType("terms");
                    }}
                  >
                    Terms of Service
                  </button>{" "}
                  and{" "}
                  <button
                    type="button"
                    className="consent-link"
                    onClick={(e) => {
                      e.preventDefault();
                      setModalType("privacy");
                    }}
                  >
                    Privacy Policy
                  </button>
                  .
                </span>
              </label>
            </div>
          </header>

          {/* Statement Card */}
          <div className="statement-section">
            <div className="statement-label">
              <span className="statement-dot"></span>
              <span className="statement-text-label">Read aloud</span>
            </div>
            <div
              className={`statement-card ${state === STATE.RECORDING ? "recording" : ""}`}
            >
              {/* <p>{stmt}</p> */}
              {stmt.map((line, i) => (
                <p key={i}>{line}</p>
              ))}
            </div>
          </div>

          {/* Recording Indicator */}
          {state === STATE.RECORDING && (
            <div className="recording-indicator">
              <div className="recording-badge">
                <span className="recording-dot"></span>
                <span className="recording-label">Recording</span>
                <span className="recording-time">{formatTime(elapsed)}</span>
                <div className="recording-wave">
                  <div className="wave-bar"></div>
                  <div className="wave-bar"></div>
                  <div className="wave-bar"></div>
                  <div className="wave-bar"></div>
                  <div className="wave-bar"></div>
                </div>
              </div>
            </div>
          )}

          {/* Playback */}
          {url && state !== STATE.RECORDING && state !== STATE.SUCCESS && (
            <div className="playback-section">
              <audio ref={audioRef} src={url} preload="metadata" />
              <div className="playback-controls">
                <button onClick={toggle} className="play-button">
                  {playing ? (
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="#fff">
                      <rect x="6" y="4" width="4" height="16" rx="1" />
                      <rect x="14" y="4" width="4" height="16" rx="1" />
                    </svg>
                  ) : (
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="#fff">
                      <path d="M8 5v14l11-7z" />
                    </svg>
                  )}
                </button>
                <div className="playback-progress">
                  <div className="progress-bar" onClick={handleProgressClick}>
                    <div
                      className="progress-fill"
                      style={{ width: `${dur > 0 ? (time / dur) * 100 : 0}%` }}
                    />
                  </div>
                  <div className="progress-time">
                    <span className="progress-played">{formatTime(time)}</span>
                    <span className="progress-total">{formatTime(dur)}</span>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Status */}
          {status && (
            <div className={`status-message ${status.t}`}>
              {status.t === "loading" && <div className="status-spinner" />}
              {status.t === "success" && (
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#34d399"
                  strokeWidth="2"
                >
                  <path d="M22 11.08V12a10 10 0 11-5.93-9.14" />
                  <path d="M22 4L12 14.01l-3-3" />
                </svg>
              )}
              {status.t === "error" && (
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#f43f5e"
                  strokeWidth="2"
                >
                  <circle cx="12" cy="12" r="10" />
                  <path d="M15 9l-6 6M9 9l6 6" />
                </svg>
              )}
              <span className="status-text">{status.m}</span>
            </div>
          )}

          {/* Buttons */}
          <div className="button-group">
            {(canRec || state === STATE.RECORDING) && (
              <button
                onClick={onRecord}
                disabled={proc || (!consentChecked && state === STATE.IDLE)}
                className={`vox-button ${state === STATE.RECORDING ? "btn-stop" : "btn-record"} ${!consentChecked && state === STATE.IDLE ? "btn-disabled-consent" : ""}`}
                title={
                  !consentChecked && state === STATE.IDLE
                    ? "Please accept the terms to continue"
                    : ""
                }
              >
                {state === STATE.RECORDING ? (
                  <>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="#fff">
                      <rect x="6" y="6" width="12" height="12" rx="2" />
                    </svg>
                    Stop Recording
                  </>
                ) : (
                  <>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="#fff">
                      <circle cx="12" cy="12" r="5" />
                    </svg>
                    {state === STATE.FAILED ? "Try Again" : "Begin Recording"}
                  </>
                )}
              </button>
            )}

            {canSub && (
              <button
                onClick={onSubmit}
                disabled={proc}
                className="submit-button"
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#fff"
                  strokeWidth="2"
                >
                  <path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z" />
                </svg>
                Submit Recording
              </button>
            )}

            {state === STATE.REVIEW && (
              <button
                onClick={onReset}
                disabled={proc}
                className="vox-button btn-reset"
              >
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M3 12a9 9 0 109-9 9.75 9.75 0 00-6.74 2.74L3 8M3 3v5h5" />
                </svg>
                Start Over
              </button>
            )}
          </div>

          {/* Hint */}
          {state === STATE.IDLE && (
            <div className="hint-box">
              <svg
                className="hint-icon"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
              >
                <circle cx="12" cy="12" r="10" />
                <path d="M12 16v-4M12 8h.01" />
              </svg>
              <p className="hint-text">
                {!consentChecked
                  ? "Please check the consent box above to enable recording."
                  : "Read the statement clearly. Your voice will be verified before submission."}
              </p>
            </div>
          )}
        </div>
      </div>

      {/* Policy Modals */}
      {modalType && (
        <PolicyModal type={modalType} onClose={() => setModalType(null)} />
      )}
    </div>
  );
}
